// 人际管理模块配置
export const contactsConfig = {
  // 模块基本信息
  name: '人际管理',
  description: '联系人、社交、人脉',
  icon: 'TeamOutlined',
  bgColor: '#BB8FCE',
  iconColor: '#FFFFFF',
  
  // API 端点
  apiEndpoints: {
    contacts: '/contacts',
    create: '/contacts',
    update: '/contacts',
    delete: '/contacts',
    records: '/contacts/records',
    addRecord: '/contacts/records',
    deleteRecord: '/contacts/records',
    stats: '/contacts/stats'
  },
  
  // 友好度选项
  friendlinessLevels: [
    { value: 'very_close', label: '很铁', color: '#52C41A', description: '关系非常亲密，可以信赖的朋友' },
    { value: 'good', label: '良好', color: '#1890FF', description: '关系不错，经常联系的朋友' },
    { value: 'normal', label: '一般', color: '#FAAD14', description: '普通朋友，偶尔联系' },
    { value: 'poor', label: '很差', color: '#FF4D4F', description: '关系疏远，很少联系' }
  ],
  
  // 关系类型选项
  relationshipTypes: [
    '同学', '同事', '朋友', '亲戚', '邻居', '合作伙伴', '客户', '导师', '学生', '其他'
  ],
  
  // 职业类型选项
  professionTypes: [
    '学生', '教师', '医生', '工程师', '设计师', '销售', '管理', '技术', '服务', '自由职业', '其他'
  ],
  
  // 人际关系处理技巧
  relationshipTips: {
    title: '人际关系处理技巧',
    sections: [
      {
        title: '沟通技巧',
        items: [
          '主动倾听：认真听对方说话，不要急于表达自己的观点',
          '共情表达：理解对方的感受，表达同理心',
          '积极反馈：对对方的想法给予积极的回应',
          '避免争论：遇到分歧时，寻求共同点而不是对立',
          '适时赞美：真诚地赞美对方的优点和成就'
        ]
      },
      {
        title: '维护关系',
        items: [
          '定期联系：保持适度的联系频率，不要过于频繁或疏远',
          '记住重要日期：生日、节日等特殊日子送上祝福',
          '分享生活：适当分享自己的生活，让对方了解你的近况',
          '提供帮助：在对方需要时主动提供力所能及的帮助',
          '保持真诚：以诚待人，建立真实的友谊关系'
        ]
      },
      {
        title: '处理冲突',
        items: [
          '冷静处理：遇到冲突时先冷静下来，避免情绪化',
          '换位思考：站在对方角度思考问题，理解对方的立场',
          '及时沟通：发现问题及时沟通，避免误会加深',
          '寻求和解：主动寻求和解，不要让矛盾长期存在',
          '学会道歉：如果自己有错，要勇于承认并道歉'
        ]
      },
      {
        title: '建立信任',
        items: [
          '言而有信：承诺的事情一定要做到，建立信用',
          '保守秘密：对方告诉你的秘密要严格保守',
          '诚实待人：不要欺骗或隐瞒重要信息',
          '承担责任：为自己的行为承担责任，不推卸责任',
          '尊重隐私：尊重对方的个人空间和隐私'
        ]
      },
      {
        title: '社交礼仪',
        items: [
          '礼貌用语：使用礼貌的语言，注意说话方式',
          '时间观念：准时赴约，尊重对方的时间',
          '礼物文化：适当的时候送一些小礼物表达心意',
          '餐桌礼仪：注意餐桌上的礼仪和举止',
          '感谢表达：及时表达感谢，让对方感受到被重视'
        ]
      }
    ]
  },
  
  // 人脉管理建议
  networkAdvice: {
    title: '人脉管理建议',
    sections: [
      {
        title: '分类管理',
        items: [
          '按关系分类：同学、同事、朋友、亲戚等',
          '按行业分类：同行业、跨行业、上下游等',
          '按地域分类：本地、外地、海外等',
          '按重要程度：核心人脉、重要人脉、一般联系等',
          '按联系频率：经常联系、偶尔联系、很少联系等'
        ]
      },
      {
        title: '价值挖掘',
        items: [
          '了解需求：了解对方的需求和痛点',
          '资源对接：帮助对方对接需要的资源',
          '信息分享：分享有价值的信息和机会',
          '技能互补：寻找技能互补的合作机会',
          '共同成长：一起学习成长，互相促进'
        ]
      },
      {
        title: '长期维护',
        items: [
          '建立档案：为每个重要联系人建立详细档案',
          '定期回顾：定期回顾和更新联系人信息',
          '记录互动：记录每次互动的内容和感受',
          '制定计划：制定人脉维护的计划和目标',
          '持续投入：在人脉关系上持续投入时间和精力'
        ]
      }
    ]
  },
  
  // 联系记录模板
  recordTemplates: [
    {
      title: '日常问候',
      content: '今天联系了{name}，问候了最近的情况，聊了聊工作和生活。'
    },
    {
      title: '生日祝福',
      content: '今天是{name}的生日，送上了生日祝福，对方很开心。'
    },
    {
      title: '工作交流',
      content: '与{name}讨论了工作相关的事情，交流了经验和想法。'
    },
    {
      title: '聚会活动',
      content: '和{name}一起参加了聚会活动，度过了愉快的时光。'
    },
    {
      title: '求助帮助',
      content: '向{name}寻求了帮助，对方很乐意提供支持。'
    },
    {
      title: '资源分享',
      content: '与{name}分享了有用的资源和信息，对方表示感谢。'
    }
  ],
  
  // 联系频率建议
  contactFrequency: {
    very_close: {
      label: '很铁',
      frequency: '每周1-2次',
      description: '关系非常亲密，可以经常联系'
    },
    good: {
      label: '良好', 
      frequency: '每月2-3次',
      description: '关系不错，保持适度联系'
    },
    normal: {
      label: '一般',
      frequency: '每季度1-2次', 
      description: '普通朋友，偶尔联系即可'
    },
    poor: {
      label: '很差',
      frequency: '每年1-2次',
      description: '关系疏远，很少联系'
    }
  }
};
